<template>
  <div>
    Stok beslemeniz gerekmektedir.
  </div>
</template>
<script>
import Index from './Index';

export default {
  name: 'IndexOutOfStock',
  extends: Index,
};
</script>
